<template>
  <div class="collect">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="list">
          <div
            class="item"
            v-for="(item, index) in list"
            :key="index"
            @click="bindClick(item)"
          >
            <img
              class="avatar"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0a8865341b353336bfe340f5e9ebf087.png"
            />
            <div class="item-r">
              <div class="item-flex">
                <div class="name">{{ item.title }}</div>
                <div class="desc">{{ item.desc }}</div>
              </div>
              <div class="iconfont icon-you"></div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
export default {
  data() {
    return {
      refreshing: false,
      loading: false,
      finished: false,
      page: 1,
      pageSize: 20,
      list: []
    }
  },
  methods: {
    onRefresh() {
      this.page = 1
      this.finished = false
      this.onLoad(true)
    },
    bindClick(item) {
      this.$router.push({
        path: '/diet-calculator/result',
        query: {
          id: item.id
        }
      })
    },
    onLoad(refresh) {
      let params = {
        pageSize: this.pageSize,
        page: this.page
      }
      this.$http
        .getBaseApp('member/DietCalculate/getCollectionList', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            if (res.data.length) {
              this.page++
              if (res.data.length < this.pageSize) {
                this.finished = true
              }
              res.data = this.filterData(res.data)
              if (refresh) {
                this.list = res.data
              } else {
                this.list = this.list.concat(res.data)
              }
            } else {
              this.s = true
            }
          } else {
            this.finished = true
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          this.finished = true
          console.log(err)
        })
        .finally(() => {
          this.loading = false
          if (refresh) {
            this.refreshing = false
          }
        })
    },
    filterData(data) {
      data.map((item) => {
        let res = item.food_type_list.map((item1) => {
          let str = item1.name + ' ' + item1.num + 'g '
          return str
        })
        item.desc = res.join('| ')
      })
      console.log(data)
      return data
    }
  }
}
</script>
<style lang="scss" scoped>
.collect {
  min-height: 100vh;
  background: #f9f9f9;

  .list {
    padding: 20px 0px 20px 20px;

    .item {
      display: flex;
      align-items: center;

      .avatar {
        width: 52px;
        height: 52px;
        border-radius: 8px;
        overflow: hidden;
        margin-right: 12px;
        object-fit: contain;
      }

      .item-r {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        padding: 15px 20px 15px 0px;
        border-bottom: 1px solid #f1f1f1;
        display: flex;
        align-items: center;

        .item-flex {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
        }

        .name {
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
          line-height: 20px;
          margin-bottom: 8px;
        }

        .desc {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.6);
          line-height: 16px;
          white-space: normal;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        .iconfont {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
